export const building = {
  rent_b_regulars: {},
  rent_b_equipments: {},
  rent_b_catchcopies: {},
  rent_b_memos: {},
  rent_b_images: {},
  rent_b_3nosuke_webs: {},
}
